import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ToastController, LoadingController } from 'ionic-angular';

import { ImcpaAppProvider } from '../../../providers/imcpaApp/imcpaApp';
// import { AddFarmPage } from '../addFarm/addFarm';
// import { FarmDashboardPage } from '../farmDashboard/farmDashboard';
// import { InAppBrowser } from '@ionic-native/in-app-browser';

@Component({
  selector: 'page-viewResource',
  templateUrl: 'viewResource.html',
  // styleUrls: [ 'viewResource.scss', '../../theme/variables.scss' ]

})
export class ViewResourcePage {
  public resource: any;
  public key: any;
 
  constructor(
    // private iab: InAppBrowser,
    public navCtrl: NavController, 
    public navParams: NavParams,
    public myApp: ImcpaAppProvider) {
      this.resource = this.navParams.get("resource")
  }

OpenUrl()
{
  // window.open("http://google.com",'_system', 'location=yes');
// const browser = this.iab.create('https://www.dev-x.co.za/MayapurIT/Goshala/MinimumCowProtectionStandards.pdf');
// browser.show()
}
  
  
  //   goToAddFarmPage(){
  //   this.navCtrl.push(AddFarmPage);
  // }

}



// WEBPACK FOOTER //
// ./src/pages/resources/viewResource/viewResource.ts